import React from 'react'

const AdobeCommunity = () => {
    return (
        <div style={{ height: 'calc(100vh - 95px)' }}>
            <iframe title='adobecommunity' src="https://express.adobe.com/page/XtZ7uluuzcWF4/" width="100%" height="100%"></iframe>
        </div>
    )
}

export default AdobeCommunity;